import { TableCell, TableRow } from "@mui/material";
import { TTableColumn } from "../../types";

function TableHeadRow(props: { columns: TTableColumn[] }) {
  return (
    <TableRow>
      {props.columns.map((column) => (
        <TableCell
          key={column.id}
          align={column.align}
          style={{
            minWidth: column.minWidth,
            maxWidth: column.maxWidth,
            width: column.width,
            wordWrap: "break-word",
            fontFamily: "Montserrat",
            fontSize: "16px",
          }}
        >
          {column.label}
        </TableCell>
      ))}
    </TableRow>
  );
}

export default TableHeadRow;
